import * as React from 'react';

import { PrimitiveTabs } from 'components';
import type {
  BrandSummary,
  FileOwnerType,
  PageBannersSettings,
  PageCategoryProductsSettings,
} from 'types';

import { PageBuilderBanners } from '../banners';
import { PageBuilderCategoryProducts } from '../category-products';
import { PageBuilderMainBrands } from '../main-brands';

type PageBuilderContentProps = {
  ownerType: FileOwnerType;
  brands: BrandSummary[];
  categoryProductsSettings: PageCategoryProductsSettings;
  bannersSettings: PageBannersSettings;
};

const PageBuilderContent = ({
  ownerType,
  brands,
  categoryProductsSettings,
  bannersSettings,
}: PageBuilderContentProps) => (
  <div className='rounded bg-white'>
    <PrimitiveTabs
      items={[
        {
          key: 'brands',
          label: 'برندها',
          children: <PageBuilderMainBrands brands={brands} />,
        },
        {
          key: 'categories',
          label: 'دسته‌بندی‌ها',
          children: (
            <PageBuilderCategoryProducts settings={categoryProductsSettings} />
          ),
        },
        {
          key: 'banners',
          label: 'بنرها',
          children: (
            <PageBuilderBanners
              settings={bannersSettings}
              ownerType={ownerType}
            />
          ),
        },
      ]}
    />
  </div>
);

export { PageBuilderContent };
